<app-wizard-modal [isLoading]="isLoading"
                  [canDelete]="true"
                  [isReadOnlyMode]="isReadyOnly"
                  [canDeleteTooltipText]="deleteTooltipText"
                  [isEditMode]="isEditMode"
                  (stepChange)="onWizardStepChange($event)"
                  (submit)="onWizardSubmit()"
                  (cancel)="onWizardCancel()"
                  (delete)="deleteLine()"
                  (modalOpened)="onModalOpened()">
    <app-wizard-title>
        <ng-container modal-header>
            <h5 class="modal-title"
                *ngIf="!isEditMode; else editTitle">{{ 'admin.lines.create-modal.title' | translate }}</h5>
            <ng-template #editTitle>
                <h5 class="modal-title">{{ 'admin.lines.update-modal.title' | translate }}</h5>
            </ng-template>
        </ng-container>
    </app-wizard-title>
    <app-wizard-step [canContinue]="lineDetailsValid">
        <ng-template #title>{{ 'admin.lines.create-modal.sections.details' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-line-details-form
                [showValidations]="step.nextTriggered"
                [isEditMode]="isEditMode"
                (spiValueChanged)="onSpiValueChanged($event)">
            </app-line-details-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="lineTransportValid">
        <ng-template #title>{{ 'admin.lines.create-modal.sections.lineSettings' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <app-line-transport-settings-form
                [showValidations]="step.nextTriggered">
            </app-line-transport-settings-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step *ngIf="this.isSPI" [canContinue]="lineInsertionCyclesValid">
        <ng-template #title>{{'admin.lines.create-modal.sections.insertionCycles' | translate}}</ng-template>
        <ng-template #content let-step="step">
            <app-line-insertion-cycles-form
                [showValidations]="step.nextTriggered">
            </app-line-insertion-cycles-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{'admin.lines.create-modal.sections.equipment' | translate}}</ng-template>
        <ng-template #content let-step="step">
            <app-line-equipment-form
                [duplicate]="duplicateMode"
                [showValidations]="step.nextTriggered">
            </app-line-equipment-form>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
